import { useId, type InputHTMLAttributes } from "react";

import { cn } from "../cn";

export type FieldProps = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string;
  error?: string | undefined;
};

/** Campo de texto com rótulo, dica e erro ligados por id (acessível). */
export function Field({ label, hint, error, className, id, ...props }: FieldProps) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const hintId = `${inputId}-hint`;
  const errorId = `${inputId}-error`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(" ");

  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={inputId} className="text-[14px] font-semibold text-ink">
        {label}
      </label>
      <input
        id={inputId}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy || undefined}
        className={cn(
          "min-h-[var(--touch)] rounded-xl border border-line bg-paper px-4 text-ui text-ink placeholder:text-muted/70",
          error && "border-[#8c2f2f]",
          className,
        )}
        {...props}
      />
      {hint && !error ? (
        <p id={hintId} className="text-[13px] text-muted">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} role="alert" className="text-[13px] font-semibold text-[#8c2f2f]">
          {error}
        </p>
      ) : null}
    </div>
  );
}
